import React from "react";
import { PageHeader } from "@/components/PageHeader";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { useAuth } from "@/context/AuthContext";
import { LedgerTable } from "@/components/tds/LedgerTable";
import { TdsReports } from "@/components/tds/TdsReports";
import { FranchisePayouts } from "@/components/tds/FranchisePayouts";
import { TdsCertificates } from "@/components/tds/TdsCertificates";

export default function TdsManagement() {
  const { canAny, user } = useAuth();
  const isFo = user?.role === "Franchise Owner";
  const tabs = [
    !isFo && canAny("tax.view") && { v: "dp", l: "Delivery Partner TDS", el: <LedgerTable category="dp" testId="dp-tds" /> },
    canAny("fr.payout_view", "fr.payout_create", "fr.payout_pay") && { v: "fr", l: isFo ? "My Commission Payouts" : "Franchise Partner TDS", el: <FranchisePayouts /> },
    canAny("tax.view") && { v: "ledger", l: "TDS Ledger", el: <LedgerTable /> },
    canAny("tax.view") && { v: "reports", l: "TDS Reports", el: <TdsReports /> },
    canAny("tax.view") && { v: "certs", l: isFo ? "My TDS Certificates" : "TDS Certificates", el: <TdsCertificates /> },
    !isFo && canAny("tax.view", "tax.deposit") && { v: "deposit", l: "TDS Deposit Tracking", el: <LedgerTable depositStatus="Pending" testId="deposit-tracking" /> },
  ].filter(Boolean);
  if (!tabs.length) return null;
  return (
    <div data-testid="tds-page">
      <PageHeader title={isFo ? "My Commission & TDS" : "TDS Management"} subtitle="Automatic TDS on DP withdrawals and franchise commission payouts — ledger, deposits, statements and reports." />
      <Tabs defaultValue={tabs[0].v}>
        <TabsList className="h-auto flex-wrap gap-1">{tabs.map((t) => <TabsTrigger key={t.v} value={t.v} data-testid={`tds-tab-${t.v}`}>{t.l}</TabsTrigger>)}</TabsList>
        {tabs.map((t) => <TabsContent key={t.v} value={t.v} className="mt-4">{t.el}</TabsContent>)}
      </Tabs>
    </div>
  );
}
